import { Link, useLocation } from 'react-router-dom'

interface LandingLayoutProps {
  children: React.ReactNode
}

export default function LandingLayout({ children }: LandingLayoutProps) {
  const location = useLocation()
  
  const navLinks = [
    { path: '/', label: 'Home' },
    { path: '/autoapply', label: 'AutoApply' },
    { path: '/how-it-works', label: 'How It Works' },
    { path: '/privacy', label: 'Privacy' },
    { path: '/requirements', label: 'Requirements' },
  ]

  return (
    <div className="min-h-screen bg-bg-page">
      <header className="bg-bg-surface border-b border-border sticky top-0 z-10">
        <nav className="max-w-5xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2 font-semibold text-xl text-text-primary">
            <img src="/PraxisCRM.png" alt="" className="h-8 w-8" />
            <span>Praxis<span className="text-action-primary">CRM</span></span>
          </Link>
          
          <div className="flex items-center gap-6">
            <ul className="hidden md:flex items-center gap-6">
              {navLinks.map(({ path, label }) => (
                <li key={path}>
                  <Link
                    to={path}
                    className={`text-sm transition-colors ${
                      location.pathname === path
                        ? 'text-action-primary font-medium'
                        : 'text-text-secondary hover:text-text-primary'
                    }`}
                  >
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
            
            <Link
              to="/login"
              className="btn btn-primary text-sm"
            >
              Sign In
            </Link>
          </div>
        </nav>
        
        {/* Mobile nav */}
        <div className="md:hidden border-t border-border px-6 py-3">
          <ul className="flex items-center justify-between">
            {navLinks.map(({ path, label }) => (
              <li key={path}>
                <Link
                  to={path}
                  className={`text-xs transition-colors ${
                    location.pathname === path
                      ? 'text-action-primary font-medium'
                      : 'text-text-secondary'
                  }`}
                >
                  {label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </header>
      
      <main>
        {children}
      </main>
      
      <footer className="border-t border-border py-8 mt-16">
        <div className="max-w-5xl mx-auto px-6 text-center text-sm text-text-secondary">
          <p className="flex items-center justify-center gap-2 mb-3">
            <img src="/PraxisCRM.png" alt="" className="h-5 w-5" />
            <span>Free forever. We can't see your data. By design.</span>
          </p>
          <nav className="flex items-center justify-center gap-4 mb-3">
            <Link to="/privacy" className="hover:text-text-primary transition-colors">
              Privacy
            </Link>
            <Link to="/terms" className="hover:text-text-primary transition-colors">
              Terms
            </Link>
          </nav>
          <p className="text-xs text-text-tertiary">
            Built by{' '}
            <a 
              href="https://www.anotherwebispossible.co.uk" 
              target="_blank" 
              rel="noopener noreferrer"
              className="hover:text-text-secondary transition-colors"
            >
              Another Web Is Possible
            </a>
          </p>
        </div>
      </footer>
    </div>
  )
}
